import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Sherpa, { TYPE_SMALL_WHITE } from '../Sherpa/index'
import { connect as connectStaticText } from '../StaticText/connect'

function CartBillingProcessing (props) {
  const { staticText, finalize, alignLeft } = props
  return (
    <div className={`cart-billing-processing${alignLeft ? ' cart-billing-processing--align-left' : ''}`}>
      <Sherpa type={TYPE_SMALL_WHITE} />
      <p className="cart-billing-processing__message">
        {
          finalize ? staticText.getIn(['data', 'yourSubscriptionIsBeinCreated'])
            : staticText.getIn(['data', 'yourAccountIsBeingCreated'])
        }
        <br />
        {staticText.getIn(['data', 'pleaseStayOnThisPage'])}
      </p>
    </div>
  )
}

CartBillingProcessing.propTypes = {
  finalize: PropTypes.bool,
  alignLeft: PropTypes.bool,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default connectStaticText({ storeKey: 'cartBillingProcessing' })(
  CartBillingProcessing,
)
